import React, { useState, useEffect } from "react";
import { PiDotsSixVertical } from "react-icons/pi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaPlus } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ModalForm from "./Modal";
import _ from "lodash";
import { URLS } from "../../../Services/Urls";
import { useSelector, useDispatch } from "react-redux";
import {
  removeProduct,
  removeFromSection,
} from "../../../Redux/Store/Slices/sectionSlice";
import AddContentModal from "./AddContentModal";
import { setActiveSection } from "../../../Redux/Store/Slices/sectionSlice";
import {
  updateSection,
  reUpdateSection,
} from "../../../Redux/Store/Slices/projectReducer";
import NestedSection from "./NestedSection";
import "./nested-sections.css";
import {
  buildProductImageUrl,
  getFallbackImageUrl,
  getProductImageUrl,
} from "../../../utils/productImage";

const MainBody = ({ sections, sectionId }) => {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(
    sections.reduce((acc, section) => ({ ...acc, [section.id]: true }), {})
  );
  const [showSelectedProducts, setShowSelectedProducts] = useState(
    sections.reduce((acc, section) => ({ ...acc, [section.id]: [] }), {})
  );
  const [selectedChoices, setSelectedChoices] = useState({});

  const selectedProducts = useSelector(
    (state) => state.products.selectedProducts
  );
  const { active_section } = useSelector((state) => state.section);
  const sectionProducts = useSelector((state) => state.project.active_section.products);
  // const selectedProducts = useSelector((state) => state.products.sections[sectionId] || []);

  useEffect(() => {
    console.log("Selected Products:", selectedProducts);
  }, [selectedProducts]); 

  useEffect(() => {
    setSelectedChoices((prevChoices) => {
      const updatedChoices = { ...prevChoices };
      sections.forEach((section) => {
        if (!(section.id in updatedChoices)) {
          updatedChoices[section.id] = null;
        }
      });
      return updatedChoices;
    });
  }, [sections]);

  const toggleSection = (sectionId) => {
    setIsActive((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  const handleAddProductModal = (event, section) => {
    event.preventDefault();
    console.log("section:", section);

    const normalizedProducts = Array.isArray(section.products) ? [...section.products] : [];

    dispatch(
      setActiveSection({
        ...section,
        products: normalizedProducts,
        contents: Array.isArray(section.contents) ? [...section.contents] : [],
        isNestedSection: false,
        initialProductIds: normalizedProducts
          .map((product) => product.product?.id || product.id)
          .filter(Boolean),
      })
    );
  };

  const handleShowSelectedProducts = (selectedProducts, sectionId) => {
    setShowSelectedProducts((prevSelectedProducts) => ({
      ...prevSelectedProducts,
      [sectionId]: selectedProducts,
    }));
    
    // Afficher un toast de confirmation
    if (selectedProducts && selectedProducts.length > 0) {
      console.log(`${selectedProducts.length} produit(s) ajouté(s) à la section ${sectionId}`);
      // Note: Le toast sera géré dans Modal.jsx après l'appel API
    }
  };

  const handleChoiceSelect = (sectionId, choiceItem) => {
    setSelectedChoices((prevChoices) => {
      const currentChoice = prevChoices[sectionId];
      const isSameChoice = currentChoice && currentChoice.id === choiceItem.id;
      const updatedChoices = {
        ...prevChoices,
        [sectionId]: isSameChoice ? null : choiceItem,
      };

      console.log(
        `Choice item ${choiceItem.label} ${
          isSameChoice ? "deselectionne" : "selectionne"
        } pour la section ${sectionId}`
      );

      return updatedChoices;
    });
  };

  // const handleRemoveProduct = (product) => {
  //   dispatch(removeProduct(product));
  //   // dispatch(removeProduct({ sectionId: sectionId, product: product }));
  //   setShowSelectedProducts((prevSelectedProducts) => ({
  //     ...prevSelectedProducts,
  //     [sectionId]: prevSelectedProducts[sectionId]?.filter((p) => p.products.id !== product.products.id),
  //   }));
  //   console.log("sectionId :", sectionId)
  // };

  const handleRemoveProduct = (product) => {
    console.log('handleRemoveProduct appelé avec:', product);
    console.log('active_section avant suppression:', active_section);
    
    // Utiliser l'ID existant du produit
    const productContent = {
      id: product.id, // Utiliser l'ID existant
      product_type: product.product_type || "",
      product: product.product
    }
    
    console.log('productContent à supprimer:', productContent);
    dispatch(removeFromSection(productContent));
    
    console.log('removeFromSection dispatché');
  };

  return (
    <>
      <div className="border-circle mt-4 p-5 rounded row-cols-lg-12">
        <div>
          {sections.map((section, idx) => {
            const choiceItems =
              (Array.isArray(section.choice_items) && section.choice_items.length > 0
                ? section.choice_items
                : Array.isArray(section.choices)
                ? section.choices
                : []) || [];
            return (
              <div key={section.id}>
              <div
                className="border-circle rounded"
                id={`section-${section.id}`}
              >
                <div className="px-2 d-flex mb-3 border-btm">
                  <div className="d-flex me-auto">
                    <button
                      type="button"
                      className="p-col-2 fs-3 border-0 bg-white"
                    >
                      <PiDotsSixVertical />
                    </button>
                    <div>
                      <p className="section-text pt-3 ps-1">
                        Section {idx + 1}: {section.name}
                      </p>
                    </div>
                  </div>
                  <div className="p-2">
                    <button
                      type="button"
                      className="btn fs-italic"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      <FaPlus /> Add Content
                    </button>
                    <AddContentModal />
                  </div>
                  <div className="p-2">
                    <button
                      onClick={() => toggleSection(section.id)}
                      type="button"
                      className="btn p-col-2 fs-3"
                    >
                      {isActive[section.id] ? (
                        <IoIosArrowUp />
                      ) : (
                        <IoIosArrowDown />
                      )}
                    </button>
                  </div>
                </div>
                {isActive[section.id] && (
                  <div>
                    {choiceItems.length > 0 && (
                      <div className="choice-items-wrapper">
                        <h6 className="ms-4 mb-3 text-muted d-flex align-items-center">
                          <i className="fas fa-check-square me-2" />
                          Choix disponibles ({choiceItems.length})
                        </h6>
                        <div className="choice-items-grid ms-3 me-3">
                          {choiceItems.map((choice) => {
                            const isSelected =
                              selectedChoices[section.id]?.id === choice.id;
                            const hasChildren =
                              Array.isArray(choice.children) &&
                              choice.children.length > 0;

                            const linkedProductImage =
                              getProductImageUrl(choice.linked_product) ||
                              getProductImageUrl(choice.product_ref);
                            const rawChoiceImage =
                              buildProductImageUrl(choice.image) ||
                              buildProductImageUrl(choice.profile_image);
                            const finalChoiceImage =
                              linkedProductImage ||
                              rawChoiceImage ||
                              getFallbackImageUrl();

                            return (
                              <button
                                key={choice.id}
                                type="button"
                                className={`choice-card ${
                                  isSelected ? "selected" : ""
                                }`}
                                onClick={() =>
                                  handleChoiceSelect(section.id, choice)
                                }
                              >
                                <div className="choice-card-header">
                                  <span className="choice-card-label">
                                    {choice.label}
                                  </span>
                                  {isSelected && (
                                    <span className="choice-card-badge">
                                      Selectionne
                                    </span>
                                  )}
                                </div>
                                {finalChoiceImage && (
                                  <div className="choice-card-image">
                                    <img
                                      src={finalChoiceImage}
                                      alt={choice.label}
                                    />
                                  </div>
                                )}
                                {choice.help_text && (
                                  <p className="choice-card-help">
                                    {choice.help_text}
                                  </p>
                                )}
                                <div className="choice-card-meta">
                                  <span>Code : {choice.code}</span>
                                  {choice.add_quantities && (
                                    <span className="choice-card-quantity">
                                      Quantite ajustable
                                    </span>
                                  )}
                                  {hasChildren && (
                                    <span className="choice-card-children">
                                      {choice.children.length} option(s)
                                      associee(s)
                                    </span>
                                  )}
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    <section>
                      <div className="row m-3">
                        {section.products?.map((product, productIndex) => {
                          const imageUrl =
                            getProductImageUrl(product.product) ||
                            getFallbackImageUrl();

                          return (
                            <div
                              key={product.product.id}
                              className="col-6 mb-4 mt-1"
                            >
                              <div
                                className=" border  d-flex justify-content-between  "
                                style={{ width: "100%" }}
                              >
                                <div className="d-flex pt-2 px-1">
                                  <div>
                                    <img
                                      className=""
                                      src={imageUrl}
                                      alt={product.product.name}
                                      style={{ width: "75px", height: "75px" }}
                                    />
                                  </div>
                                  <div className="design-text px-3">
                                    <span>{product.product.name}</span>
                                    <br />
                                    <p className="p-col mt-1">
                                      <span className="p-6-d me-4">
                                        Price: £{product.product.price}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                <div className="position-relative me-3">
                                  <div className="text-top d-flex justify">
                                    <button
                                      type="button"
                                      className="btn bg-warning-subtle text-remove fw-bold fst-italic"
                                    >
                                      <Link
                                        className="p-col text-remove"
                                        onClick={() =>
                                          handleRemoveProduct(
                                            product
                                          )
                                        }
                                      >
                                        Remove
                                      </Link>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </section>
                    
                    {/* Afficher les sections imbriquées */}
                    {section.nested_sections && section.nested_sections.length > 0 && (
                      <div className="nested-sections-container mt-4">
                        <h6 className="ms-4 mb-3 text-muted">
                          <i className="fas fa-layer-group me-2"></i>
                          Sections Imbriquées ({section.nested_sections.length})
                        </h6>
                        {section.nested_sections.map((nestedSection) => (
                          <NestedSection 
                            key={nestedSection.id} 
                            nestedSection={nestedSection} 
                            level={0}
                          />
                        ))}
                      </div>
                    )}
                    
                    <hr className="ms-4" style={{ width: "95%" }} />
                    <div>
                      <div>
                        <button
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target={`#exampleModal-${section.id}`}
                          className="rounded border-dash mb-4 ms-4 pe-auto text-center fw -bold fst-italic py-2 bg-white p-6-d"
                          style={{ width: "95%" }}
                          onClick={(event) => handleAddProductModal(event, section)}
                        >
                          Add Product
                        </button>
                      </div>
                      <ModalForm
                        sectionId={section.id}
                        onShowSelectedProducts={(selectedProducts) =>
                          handleShowSelectedProducts(
                            selectedProducts,
                            section.id
                          )
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
              <hr className="my-4" />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default MainBody;
